<script setup>
import { defineAsyncComponent } from 'vue';

import { formStore } from '@/stores/form.js';

const form = formStore();

const TheFilter = defineAsyncComponent(() => import(`@/components/Views/Funnels/${form.funnelType}/components/TheFilter.vue`));
</script>

<template>
  <BaseOffCanvas
    target="filterMobile"
    :title="$t('premium-overview.filter')"
  >
    <component :is="TheFilter" />
  </BaseOffCanvas>
</template>
